enum DemoEndpoints {
    GuestDetails = "guest-details.json",
    GetGuestVehicle = "getguestvehicle.json",
    OnDemand = "ondemand.json",
    VehicleByVin = "vehicle-unit-by-vin.json",
    AirportLoungeBalance = "airport-lounge-balance.json",
    ValetBalance = "valet-balance.json",
    AllRewards = "all-rewards.json",
    OnDemandBookings = "ondemand-bookings.json",
    ValetPartners = "valet-partners.json",
    OnDemandLocations = "ondemand-locations.json",
    OnDemandVehicles = "ondemand-vehicles.json",
    Payments = "payments.json",
    Bookings = "bookings.json",
    Empty = "empty.json",
}

const DEMO_JSON_PUBLIC_FOLDER = "/demo/json/";

export const guestServiceDemoUser = (): Promise<LXS.GuestDetails> => {
    return fetch(DEMO_JSON_PUBLIC_FOLDER + DemoEndpoints.GuestDetails)
        .then(response => response.json())
        .then((data: LXS.GuestDetails) => {
            return data;
        })
        .catch(error => {
            throw error;
        });
};

const getDemoApiEndpoint = (endPoint: RequestInfo): string => {
    const endPointString = endPoint instanceof Request ? endPoint.url : endPoint;
    if (/getguestvehicle/i.test(endPointString)) return DemoEndpoints.GetGuestVehicle;
    if (/ondemand\?accountId/i.test(endPointString)) return DemoEndpoints.OnDemand;
    if (/vehicleunits\/vins/i.test(endPointString)) return DemoEndpoints.VehicleByVin;
    if (/airportlounge/i.test(endPointString)) return DemoEndpoints.AirportLoungeBalance;
    if (/valet\/balance/i.test(endPointString)) return DemoEndpoints.ValetBalance;
    if (/allrewards/i.test(endPointString)) return DemoEndpoints.AllRewards;
    if (/bookings/i.test(endPointString)) return DemoEndpoints.OnDemandBookings;
    if (/valet\/partners/i.test(endPointString)) return DemoEndpoints.ValetPartners;
    if (
        // This regex matches the pattern for fetching vehicles in a specific location and date range
        // eg: ondemand/locations/259/vehicles/2025-06-21/10:00/2025-06-28/10:00
        /ondemand\/locations\/\d+\/vehicles\/\d{4}-\d{2}-\d{2}\/\d{2}:\d{2}\/\d{4}-\d{2}-\d{2}\/\d{2}:\d{2}/i.test(
            endPointString
        )
    )
        return DemoEndpoints.OnDemandVehicles;
    if (/ondemand\/locations/i.test(endPointString)) return DemoEndpoints.OnDemandLocations;
    if (/payments/i.test(endPointString)) return DemoEndpoints.Payments;
    if (/ondemand\/bookings/i.test(endPointString)) return DemoEndpoints.Bookings;
    return DemoEndpoints.Empty;
};

export const getDemoResponse = (endPoint: RequestInfo): Promise<Response> => {
    const demoApiEndpoint = DEMO_JSON_PUBLIC_FOLDER + getDemoApiEndpoint(endPoint);
    return fetch(demoApiEndpoint);
};
